import { useTranslations } from 'next-intl';
import { AlertDialogCancel } from '~/components/ui/alert-dialog';
import { Button, type ButtonProps } from '~/components/ui/button';
import { DialogClose } from '~/components/ui/dialog';
import { LoadingButton } from './loading-button';
export const DialogCloseButton = ({
  disabled,
  type = 'cancel',
  onClick
}: {
  disabled: boolean;
  type?: 'cancel' | 'close';
  onClick?: () => void;
}) => {
  const t = useTranslations('DialogCloseButton');
  return <DialogClose asChild data-sentry-element="DialogClose" data-sentry-component="DialogCloseButton" data-sentry-source-file="dialog-actions.tsx">
      <Button variant="outline" disabled={disabled} onClick={onClick} data-sentry-element="Button" data-sentry-source-file="dialog-actions.tsx">
        {type === 'cancel' ? t('cancel') : t('close')}
      </Button>
    </DialogClose>;
};
export const AlertDialogCancelButton = ({
  disabled,
  type = 'cancel'
}: {
  disabled: boolean;
  type?: 'cancel' | 'close';
}) => {
  const t = useTranslations('AlertDialogCancelButton');
  return <AlertDialogCancel disabled={disabled} data-sentry-element="AlertDialogCancel" data-sentry-component="AlertDialogCancelButton" data-sentry-source-file="dialog-actions.tsx">{type === 'cancel' ? t('cancel') : t('close')}</AlertDialogCancel>;
};
export const DialogSaveButton = ({
  isLoading,
  disabled,
  form,
  onClick
}: {
  isLoading: boolean;
  disabled?: boolean;
  form?: string;
  onClick?: () => void;
}) => {
  const t = useTranslations('DialogSaveButton');
  return <LoadingButton isLoading={isLoading} loadingContent={t('saving')} type="submit" disabled={disabled} form={form} onClick={onClick} data-sentry-element="LoadingButton" data-sentry-component="DialogSaveButton" data-sentry-source-file="dialog-actions.tsx">
      {t('save')}
    </LoadingButton>;
};
export const DialogCreateButton = ({
  isLoading,
  disabled = false,
  onClick,
  label,
  variant,
  form
}: {
  isLoading: boolean;
  disabled?: boolean;
  onClick?: () => void;
  label?: string;
  variant?: ButtonProps['variant'];
  form?: string;
}) => {
  const t = useTranslations('DialogCreateButton');
  return <LoadingButton disabled={disabled} isLoading={isLoading} loadingContent={label ? undefined : t('creating')} type={onClick ? 'button' : 'submit'} onClick={onClick} variant={variant} form={form} data-sentry-element="LoadingButton" data-sentry-component="DialogCreateButton" data-sentry-source-file="dialog-actions.tsx">
      {label ?? t('create')}
    </LoadingButton>;
};
export const DialogDeleteButton = ({
  isDisabled,
  isLoading,
  onClick,
  label,
  loadingContent
}: {
  isDisabled?: boolean;
  isLoading: boolean;
  onClick?: () => void;
  label?: string;
  loadingContent?: string;
}) => {
  const t = useTranslations('DialogDeleteButton');
  return <LoadingButton disabled={isDisabled ?? false} variant="destructive" isLoading={isLoading} loadingContent={loadingContent ?? t('deleting')} type={onClick ? 'button' : 'submit'} onClick={onClick} data-sentry-element="LoadingButton" data-sentry-component="DialogDeleteButton" data-sentry-source-file="dialog-actions.tsx">
      {label ?? t('delete')}
    </LoadingButton>;
};